const SLIDER_SIZES = {
  default: 3,
  thick: 4,
}

export { SLIDER_SIZES }
